import script from "./NavigationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationPanel.vue?vue&type=script&setup=true&lang=js"

import "./NavigationPanel.vue?vue&type=style&index=0&id=48ca2550&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ca2550"]])

export default __exports__